var data = [
  {
    title: "App Stack Overflow",
    sectionText: `<p>How many applications does it take to land a job?</p>
                <p>Just one.</p>
                <p>But let’s face it: many more will come first.</p>
                <p><span class="blue">Apply Yourself</span> will keep your job applications organized and allow you to spend more time levelling up your skills!</p>
                </div>
              `,
    sectionImage:
      "https://images.unsplash.com/photo-1456406644174-8ddd4cd52a06?ixlib=rb-0.3.5&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1080&fit=max&ixid=eyJhcHBfaWQiOjF9&s=ee742bee0f10b97a9d117d410d4887c8",
    sectionBg: "grey-bg"
  },
  {
    title: "Coordinate the Clutter",
    sectionText: `<p>Forget which cover letter you sent where?
                <p><span class="blue">Track each step</span> of the application process
                for each job, from resumes to interviews
                to job offers.</p>
                <p>Compare your prospects to choose which job suites you best!</p>
                `,
    sectionImage: `https://images.unsplash.com/photo-1503551723145-6c040742065b?ixlib=rb-0.3.5&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1080&fit=max&ixid=eyJhcHBfaWQiOjF9&s=cfcb36b45801576b92d7a537edb53ac1`
  },
  {
    title: "Always Progressing",
    sectionText: `<p>How’d that interview go?</p>
                <p><span class="blue">Mark your progress</span> on each job prospect
                and find out where your weak points lie.</p>
                <p>Then hone your skills to reach maximum potential and land your next job!</p>
                `,
    sectionImage:
      "https://images.unsplash.com/photo-1507099985932-87a4520ed1d5?ixlib=rb-0.3.5&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1080&fit=max&ixid=eyJhcHBfaWQiOjF9&s=6227a3e0898cc8a411a8e10cdee75db4"
  }
];

export default data;



// WEBPACK FOOTER //
// ./src/components/pages/landing-page-data.js